export default __webpack_public_path__ + "static/media/importPreview.6f472031.png";